import { Directive, Input, TemplateRef, ViewContainerRef, ChangeDetectorRef, effect, inject } from '@angular/core';
import { DealerClaim } from '@core/models/dealer.model';
import { DealerStateSelectors } from '@core/states/dealer/dealer-state.selectors';
import { select } from '@ngxs/store';

@Directive({
  selector: '[appAllowSettings]',
  standalone: true,
})
export class AllowSettingsDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private cd = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      if (this.activeDealerClaims()) {
        this.viewContainer.clear();
        if (this.hasAllowedDealerClaim(this.activeDealerClaims())) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.cd.detectChanges();
        } else {
          this.viewContainer.clear();
        }
      }
    });
  }

  allowedSettings: string[];

  activeDealerClaims = select(DealerStateSelectors.activeDealerClaims);

  @Input() set appAllowSettings(allowedSettings: string[]) {
    this.allowedSettings = allowedSettings;
  }

  private hasAllowedDealerClaim(activeDealerClaims: DealerClaim[]): boolean {
    return activeDealerClaims.filter(activeDealerClaim => this.allowedSettings.includes(activeDealerClaim.name)).length > 0;
  }
}
